import Vue from 'vue';
import Component from 'vue-class-component';
import Router from 'vue-router';
import account from '@/router/account';
import admin from '@/router/admin';
import myCreate from '@/router/my-create';
import myPage from '@/router/my-page';
import { Authority } from '@/shared/security/authority';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

const Home = () => import('@/core/home/home.vue');
const Discovery = () => import('@/v2/discovery/DiscoveryView.vue');
const Error = () => import('@/core/error/error.vue');
const RedirectComponent = () => import('@/core/redirect/redirect.vue');
const MyBriefing = () => import('@/entities/briefing/my-briefing/my-briefing.vue');
const MyBriefingList = () => import('@/entities/briefing/my-briefing/my-briefing-list/my-briefing-list.vue');
const MyBriefingDetail = () => import('@/entities/briefing/my-briefing/my-briefing-detail/my-briefing-detail.vue');
const SocialBriefingList = () => import('@/entities/briefing/social-briefing/social-briefing-list/social-briefing-list.vue');
const SocialBriefingDetail = () => import('@/entities/briefing/social-briefing/social-briefing-detail/social-briefing-detail.vue');
const SocialBriefing = () => import('@/entities/briefing/social-briefing/social-briefing.vue');
const SocialUser = () => import('@/entities/social-user/social-user.vue');
// const ResourceManagementComponent = () => import('@/entities/resource-management/resource-management.vue');
// const Search = () => import('@/entities/search/search.vue');
// const SearchAll = () => import('@/entities/search/all/search-all.vue');
// const SearchBriefing = () => import('@/entities/search/briefing/search-briefing.vue');
// const SearchDiscovery = () => import('@/entities/search/discovery/search-discovery.vue');
// const SearchReport = () => import('@/entities/search/report/search-report.vue');
// const SearchPeople = () => import('@/entities/search/people-company/search-people-company.vue');
const MobileView = () => import('@/entities/mobile-view/mobile-view.vue');
const PrivacyPolicy = () => import('@/account/register/privacy-policy/privacy-policy.vue');
const TermsOfUse = () => import('@/account/register/terms-of-use/terms-of-use.vue');
const IntroComponent = () => import('@/shared/intro/intro.vue');
const ReportShare = () => import('@/entities/report-insights/makerthon-report-details/report-share.vue');
const HomeScrapAgent = () => import('@/entities/scrap-agent/home-scrap-agent/home-scrap-agent.vue');
const PlanPricingComponent = () => import('@/v2/components/payment/plan-pricing/plan-pricing.vue');
const PaymentSuccessComponent = () => import('@/v2/components/payment/payment-success/payment-success.vue');
const Recap = () => import('@/entities/recap/recap.vue');
const PaymentFailComponent = () => import('@/v2/components/payment/payment-fail/payment-fail.vue');
const ScrapList = () => import('@/entities/scrap-agent/home-scrap-agent/content/list/list.vue');
const ScrapDetail = () => import('@/entities/scrap-agent/home-scrap-agent/content/scrap-detail-page/ScrapDetailPage.vue');
const MyRecap = () => import('@/v2/components/recap/recap/recap.vue');

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'Home' }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/discovery',
      name: 'Discovery',
      component: Discovery
    },
    {
      path: '/my-briefing',
      name: 'MyBriefing',
      component: MyBriefing,
      meta: { authorities: [Authority.USER] },
      children: [
        { path: '', name: 'MyBriefing-All', component: MyBriefingList, meta: { showMyBriefingSidebar: true, authorities: [Authority.USER] } },
        { path: 'my-recap', name: 'MyRecap', component: MyRecap, meta: { showMyBriefingSidebar: true, authorities: [Authority.USER] }},
        { path: 'social', name: 'SocialBriefing-All', component: SocialBriefingList, meta: { showMyBriefingSidebar: true, authorities: [Authority.USER] }},
        { path: 'company', name: 'CompanyBriefing-All', component: SocialBriefingList, meta: { showMyBriefingSidebar: true}},
        { path: 'social-user/:agentKey', name: 'SocialUser', component: SocialUser, meta: { authorities: [Authority.USER] } },
        { path: ':bpId', name: 'MyBriefing-Detail', component: MyBriefingDetail, meta: { showMyBriefingSidebar: true, authorities: [Authority.USER] } },
        { path: 'social/:bpId', name: 'SocialBriefing-Detail', component: SocialBriefingDetail, meta: { showMyBriefingSidebar: true }},
        { path: 'company/:bpId', name: 'CompanyBriefing-Detail', component: SocialBriefingDetail, meta: { showMyBriefingSidebar: true}}
      ]
    },
    // {
    //   path: '/my-report',
    //   name: 'MyReport',
    //   component: MyReport,
    //   meta: {
    //     authorities: [Authority.USER]
    //   },
    //   children: [
    //     { path: '', name: 'MyReport-All', component: MyReportListComponent },
    //     { path: '', name: 'MyReport-Sidebar', component: MyReportSidebar, meta: { showMyReportSidebar: true } },
    //   ]
    // },
    {
      path: '/social-briefing',
      name: 'SocialBriefing',
      component: SocialBriefing,
      children: [
        { path: '', name: 'SocialBriefing-All', component: SocialBriefingList, meta: { showSocialBriefingSidebar: true } },
        {
          path: 'featured',
          name: 'SocialBriefing-Featured',
          component: SocialBriefingList,
          meta: { showSocialBriefingSidebar: true }
        },
        {
          path: ':bpId',
          name: 'SocialBriefing-Detail',
          component: SocialBriefingDetail,
          meta: { showSocialBriefingSidebar: true }
        }
      ]
    },
    {
      path: '/social-user/:agentKey',
      name: 'SocialUser',
      component: SocialUser
    },
    {
      path: '/scrap-agent',
      name: 'ScrapAgent',
      component: HomeScrapAgent,
      meta: {
        authorities: [Authority.USER]
      },
      children: [
        {
          path: '', name: 'ScrapAgent-All', component: ScrapList, meta: {authorities: [Authority.USER]}
        },
        {
          path: ':bpId', name: 'ScrapAgent-Detail', component: ScrapDetail, meta: {authorities: [Authority.USER]}
        }
      ]
    },
    {
      path: '/Makerthon-report-detail/:userId',
      name: 'Makerthon',
      component: ReportShare,
      props: true,
      meta: {
        hideNavBar: true,
      }
    },
    {
      path: '/payment-success',
      name: 'Payment Success',
      component: PaymentSuccessComponent,
      props: true,
      meta: {
        hideNavBar: true,
        hideNoticePromotion: true,
        authorities: [Authority.USER]
      }
    },
    {
      path: '/payment-fail',
      name: 'Payment Fail',
      component: PaymentFailComponent,
      props: true,
      meta: {
        hideNavBar: true,
        authorities: [Authority.USER]
      }
    },
    // {
    //   path: '/resource',
    //   name: 'Resource',
    //   component: ResourceManagementComponent
    // },
    // {
    //   path: '/search',
    //   name: 'Search',
    //   component: Search,
    //   children: [
    //     { path: '', name: 'SearchAll', component: SearchAll },
    //     { path: 'briefing', name: 'SearchBriefing', component: SearchBriefing },
    //     { path: 'discovery', name: 'SearchDiscovery', component: SearchDiscovery },
    //     { path: 'report', name: 'SearchReport', component: SearchReport },
    //     { path: 'people', name: 'SearchPeople', component: SearchPeople }
    //   ]
    // },
    {
      path: '/mobile',
      name: 'MobileView',
      component: MobileView,
      meta: { hideNavBar: true }
    },
    // {
    //   name: 'Detail',
    //   path: '/detail-feed/:connectomeId/:feedId',
    //   component: DsFeedDetail,
    //   props: true,
    //   meta: { authorities: [Authority.USER] }
    // },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true },
      redirect: { name: 'Home' }
    },
    {
      path: '/deepsignal/:shortUrl',
      name: 'RedirectComponent',
      props: true,
      component: RedirectComponent
    },
    // {
    //   name: 'Detail-report',
    //   path: '/detail-report/:reportId',
    //   component: DsReportDetail,
    //   props: true,
    //   meta: { authorities: [Authority.USER] }
    // },
    {
      name: 'PrivacyPolicy',
      path: '/privacy-policy',
      component: PrivacyPolicy,
      props: true,
    },
    {
      name: 'TermsOfUse',
      path: '/terms-of-service',
      component: TermsOfUse,
      props: true,
    },
    {
      name: 'Recap',
      path: '/recap/:recapId',
      component: Recap,
      meta: {
        hideNavBar: true,
        showGuestNavBar: true,
        recap: false
      }
    },
    {
      name: 'Pricing Plan ',
      path: '/pricing-plan',
      component: PlanPricingComponent
    },
    {
      name: 'Intro',
      path: '/intro',
      component: IntroComponent
    },
    ...account,
    ...admin,
    ...myCreate,
    ...myPage
  ]
});
